import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSkipNext = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.6364 7C21.3895 7 22 7.54365 22 8.21427V15.7857C22 16.4564 21.3895 17 20.6364 17C19.8832 17 19.2727 16.4564 19.2727 15.7857V13.0427L11.6274 16.892C11.1764 17.1191 10.6289 16.976 10.3517 16.5762L10.2927 16.4794C10.2198 16.3426 10.1818 16.1907 10.1818 16.0367V13.2609L3.36611 16.892C2.93987 17.1191 2.42248 16.976 2.16051 16.5762L2.10474 16.4794C2.03592 16.3426 2 16.1907 2 16.0367V7.96315C2 7.43121 2.41902 7 2.9359 7C3.08562 7 3.23315 7.03697 3.36612 7.10779L10.1818 10.7382V7.96315C10.1818 7.46668 10.5681 7.05794 11.0643 7.00565L11.1722 7C11.3306 7 11.4867 7.03697 11.6274 7.10779L19.2727 10.9564V8.21427C19.2727 7.58309 19.8135 7.0644 20.505 7.00556L20.6364 7Z", fill: props.fill }));
});
export default SvgSkipNext;
